var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCryptoThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E8B923"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0449 25.813C21.4405 25.813 25.8145 21.4391 25.8145 16.0435C25.8145 10.6479 21.4405 6.27393 16.0449 6.27393C10.6494 6.27393 6.27539 10.6479 6.27539 16.0435C6.27539 21.4391 10.6494 25.813 16.0449 25.813ZM15.2716 22.5869H14.4695V21.2001H12.7304V10.7429H14.4695V9.34114H15.2716V10.7429H16.3661V9.34114H17.1756V10.7579C18.8848 10.8704 19.9642 11.8599 19.9642 13.3516C19.9642 14.476 19.1321 15.458 18.0602 15.6304V15.6904C19.477 15.8178 20.474 16.8448 20.474 18.2316C20.474 19.9932 19.2296 21.1026 17.1756 21.1926V22.5869H16.3661V21.2001H15.2716V22.5869ZM16.3511 12.2197H14.6269V15.1282H16.0587C17.363 15.1282 18.0977 14.6035 18.0977 13.6215C18.0977 12.7144 17.453 12.2197 16.3511 12.2197ZM14.6269 16.4925V19.7233H16.441C17.7978 19.7233 18.5474 19.1761 18.5474 18.0967C18.5474 17.0397 17.7828 16.4925 16.3586 16.4925H14.6269Z",
    fill: "white"
  })));
}

export default SvgCryptoThumb;